import React, { Component } from 'react';
import { connect } from 'react-redux';
import { segmentTrackEvent } from '../../utils';

const withArticleTrackingUnconnected = WrappedComponent => class extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.determineIfTrackable = this.determineIfTrackable.bind(this);
    this.createEventSpecificTracker = this.createEventSpecificTracker.bind(this);
    this.createArticleClickedTracker = this.createArticleClickedTracker.bind(this);
    this.createSocialRedirectedTracker = this.createSocialRedirectedTracker.bind(this);
    this.createArticleSharedTracker = this.createArticleSharedTracker.bind(this);
  }

  // allows the onClick prop (if passed in) to be called alongside the tracking call
  handleClick(e) {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
    this.determineIfTrackable(e);
  }

  determineIfTrackable(e) {
    const { target } = e;
    const targetTagName = target.tagName.toLowerCase();

    // this currently checks HTML tagnames but it would be more flexible to check a dataLinkType prop or data-link-type attribute instead.
    if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
      let trackableElement = target;
      let innerHTML = '';
      if (targetTagName === 'img') {
        trackableElement = target.parentNode;
        innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
      } else {
        ({ innerHTML } = target);
      }

      const eventName = this.props.dataEventName || 'article_clicked'; // may want to remove the default value at some point. it's currently needed though.
      const eventSpecificTracker = this.createEventSpecificTracker(trackableElement, eventName, innerHTML);
      return segmentTrackEvent(eventName, eventSpecificTracker, this.props.standardArticleTracker);
    }
    return false;
  }

  createEventSpecificTracker(target, eventName, innerHTML) {
    switch (eventName) {
      case 'social_redirected':
        return this.createSocialRedirectedTracker(target);
      case 'article_shared':
        return this.createArticleSharedTracker(target);
      case 'article_clicked':
        return this.createArticleClickedTracker(target, innerHTML);
      default:
        return false;
    }
  }

  createArticleClickedTracker(target, innerHTML) {
    const destinationUrl = target.getAttribute('href');
    const linkType = target.getAttribute('data-link-type') || 'text-link';
    const { moduleName } = this.props;
    const articleClickedTracker = {
      destinationUrl,
      module: moduleName,
      hypercontext: innerHTML, // need to handle this more elegantly
      category: linkType,
      linkType,
      label: destinationUrl,
    };
    return articleClickedTracker;
  }

  createSocialRedirectedTracker(target) {
    const destinationUrl = target.getAttribute('href');
    const { moduleName, actionType } = this.props;

    const socialRedirectedTracker = {
      actionType,
      module: moduleName,
      category: actionType,
      label: moduleName,
      destinationUrl,
    };
    return socialRedirectedTracker;
  }

  createArticleSharedTracker(target) {
    const { moduleName, actionType, component } = this.props;

    const articleSharedTracker = {
      actionType,
      module: moduleName,
      category: actionType,
      label: moduleName,
      component,
    };
    return articleSharedTracker;
  }

  render() {
    const {
      wrapperClassName,
      dataEventName,
      actionType,
      moduleName,
      standardArticleTracker,
      onClick,
      ...rest
    } = this.props;
    const propsWithTrackHandler = {
      ...rest,
      onClick: this.handleClick,
    };

    const renderedChildComponent = wrapperClassName ? (
      <div className={wrapperClassName} onClick={this.handleClick}>
        <WrappedComponent {...rest} />
      </div>
    ) : (
      <WrappedComponent {...propsWithTrackHandler} />
    );

    return renderedChildComponent;
  }
};

const mapStateToProps = ({ standardArticleTracker }) => ({
  standardArticleTracker,
});

const withArticleTracking = WrappedComponent => connect(mapStateToProps)(withArticleTrackingUnconnected(WrappedComponent));

export default withArticleTracking;
